<template>
  <div>
    <div
      class="column-item"
      v-for="(item, index) in dataList"
      :key="index"
    >
      {{ item }}
    </div>

    <div
      class="column-item"
      v-if="tableData.showHover"
    >
      <popover-text
        class="account"
        :line="1"
        :text="popover"
        :subText="popover"
        :width="tableData.popoverWidth"
        :disabled="tableData.disabled"
      >
        <div
          slot="component"
          class="column-item"
          v-for="(item, index) in scope.row[tableData.bind]"
          :key="index"
        >
          {{ item }}
        </div>
      </popover-text>
    </div>
  </div>
</template>

<script>
import popoverText from '@/components/tools/popoverText.vue'
export default {
  name: 'columnList',
  props: {
    tableData: Object,
    scope: Object
  },
  computed: {
    dataList() {
      let { scope, tableData } = this
      if (!tableData.showHover) {
        return scope.row[tableData.bind] || []
      }
      return []
    },
    popover() {
      let { scope, tableData } = this
      if (scope.row[tableData.bind]) {
        return scope.row[tableData.bind][0] || '-'
      }
      return '-'
    }
  },
  components: {
    popoverText
  }
}
</script>

<style scoped>
.column-item {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
